import React, { useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import Alert from "../Alert";
import { uploadStudentDeviceLog, uploadStaffDeviceLog } from "../../api/attendanceApi";

/**
 * Upload a device-exported .txt punch log (one line per punch: user id,
 * date, time, punch type, device serial — whitespace/tab separated). Direct
 * replacement for digicampusbd's file-upload half of "machine attendance";
 * the other half (a hardcoded third-party cloud API call) is intentionally
 * not carried forward — see DeviceAttendanceLog javadoc in the backend.
 */
export default function DeviceLogUpload({ subjectType, title }) {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setError("Please choose a .txt file first.");
      return;
    }
    setUploading(true);
    setError("");
    setSuccess("");
    try {
      const upload = subjectType === "STAFF" ? uploadStaffDeviceLog : uploadStudentDeviceLog;
      const result = await upload(file);
      setSuccess(result.message);
      setFile(null);
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.message) || "Upload failed.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <MainLayout>
      <div className="page-header">
        <h1>{title}</h1>
      </div>

      <Alert type="error" onDismiss={() => setError("")}>
        {error}
      </Alert>
      <Alert type="success" onDismiss={() => setSuccess("")}>
        {success}
      </Alert>

      <p>
        Upload the biometric device's exported punch log (<code>.txt</code>). Each line: device user id, date
        (yyyy-MM-dd), time (HH:mm), punch type, device serial.
      </p>

      <form onSubmit={handleSubmit} className="user-form">
        <input type="file" accept=".txt,text/plain" onChange={(e) => setFile(e.target.files[0])} />
        <div className="form-actions">
          <button type="submit" className="btn-primary" disabled={uploading}>
            {uploading ? "Uploading..." : "Upload"}
          </button>
        </div>
      </form>
    </MainLayout>
  );
}
